import { Component, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'form-date',
  templateUrl: './date.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: DateComponent,
    multi: true
  }]
})
export class DateComponent implements OnInit, ControlValueAccessor {
  @Input() type = 'date';
  @Input() icon: string;
  @Input() name: string;
  @Input() label: string;
  @Input() required = false;
  @Input() readonly = false;
  @Input() disabled = false;
  @Input() step: number;
  @Input() min: number;
  @Input() max: number;
  @Input() data: string;
  @Input() list: string;
  @Input()
  get value(): string {
    // if (!this._value) {
    // return ;
    // } else
    return this._value;
  }
  set value(value: string) {
    this._value = value;
  }

  private _value: string;

  // It will have a reference to a function that handles changing state of the control
  private _onChangeFn: (value: any) => void = _ => { };

  constructor() { }

  ngOnInit() {

  }

  onChange(event) {
    this._onChangeFn(event.target.value);
  }

  // TODO: This should probably be parsed to number
  writeValue(value: any) {
    this.value = value;
  }


  registerOnChange(fn) { this._onChangeFn = fn; }

  // TODO: Implement this
  registerOnTouched(fn) { }


}
